import { render } from "./ActivateTableModalComponent.vue?vue&type=template&id=764969c6&scoped=true"
import script from "./ActivateTableModalComponent.vue?vue&type=script&lang=js"
export * from "./ActivateTableModalComponent.vue?vue&type=script&lang=js"

import "./ActivateTableModalComponent.vue?vue&type=style&index=0&id=764969c6&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-764969c6"]])

export default __exports__